import { render, staticRenderFns } from "./MenuItemLimitAddEdit.vue?vue&type=template&id=f78f0b5a"
import script from "./MenuItemLimitAddEdit.vue?vue&type=script&lang=js"
export * from "./MenuItemLimitAddEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports